(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.header = this.querySelector('.header');
      this.stickyType = this.getAttribute('data-sticky-type');
      this.setHeaderHeight();
      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
      this.initializeMobileMenu();
      if (this.stickyType === 'none') return;
      


      this.headerIsAlwaysSticky = this.stickyType === 'always' || this.stickyType === 'reduce-logo-size';
      this.headerBounds = {};
      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
      this.createObserver();
    }

/* --- Multi-Panel Menu Javascript --- */
    initializeMobileMenu() {
      const mobileMenu = this.querySelector('.header__menu-mobile');
      if (! mobileMenu) return;
      


      const menuContent = mobileMenu.querySelector('.mobile-menu-content');
      const closeBtn = mobileMenu.querySelector('.mobile-menu-close');
      const overlay = document.querySelector('.mobile-menu-overlay');
      if (! menuContent || ! closeBtn || ! overlay) return;
      


      const accordionToggles = mobileMenu.querySelectorAll('.mobile-submenu-toggle');
      const panelTriggers = mobileMenu.querySelectorAll('.mobile-submenu-trigger');
      const backButtons = mobileMenu.querySelectorAll('.mobile-menu-back');

      const closeMenu = (e) => {
        if (e) {
          e.preventDefault();
          e.stopPropagation();
        }
        mobileMenu.open = false;
      };

// 1. Accordion Logic (for regular submenus)
      accordionToggles.forEach(toggle => {
        toggle.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          const parent = toggle.closest('.mobile-menu-item-with-submenu');
          const isExpanded = parent.classList.contains('active');

// Close other accordions
          accordionToggles.forEach(otherToggle => {
            if (otherToggle !== toggle) {
              otherToggle.closest('.mobile-menu-item-with-submenu').classList.remove('active');
            }
          });

// Toggle current one
          parent.classList.toggle('active', ! isExpanded);
        });
      });

// 2. Panel Slider Logic (for "Our Series")
      panelTriggers.forEach(trigger => {
        trigger.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          menuContent.classList.add('submenu-is-active');
        });
      });

// 3. Back Button Logic
      backButtons.forEach(button => {
        button.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          menuContent.classList.remove('submenu-is-active');
        });
      });

// 4. Main Close Triggers
      closeBtn.addEventListener('click', closeMenu);
      overlay.addEventListener('click', closeMenu);

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && mobileMenu.open) {
          closeMenu(e);
        }
      });

// 5. Click Outside (to close entire menu)
      document.addEventListener('click', (e) => {
        if (mobileMenu.open && ! mobileMenu.contains(e.target)) {
          closeMenu(e);
        }
      });

// 6. Reset menu on close
      mobileMenu.addEventListener('toggle', () => {
        if (mobileMenu.open) {
          document.body.style.overflow = 'hidden';
        } else {
          document.body.style.overflow = '';

// Reset all states
          setTimeout(() => {
            menuContent.classList.remove('submenu-is-active');
            accordionToggles.forEach(toggle => {
              toggle.closest('.mobile-menu-item-with-submenu').classList.remove('active');
            });
          }, 500);
        }
      });
    }

    setHeaderHeight() {
      if (this.header) {
        document.documentElement.style.setProperty('--header-height', `${
          this.header.offsetHeight
        }px`);
      }
    }
    disconnectedCallback() {
      if (this.stickyType !== 'none') {
        this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
        window.removeEventListener('scroll', this.onScrollHandler);
      }
    }
    createObserver() {
      if (this.header) {
        let observer = new IntersectionObserver((entries, observer) => {
          this.headerBounds = entries[0].intersectionRect;
          observer.disconnect();
        });
        observer.observe(this.header);
      }
    }
    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        


        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }
      this.currentScrollTop = scrollTop;
    }
    hide() {
      if (this.headerIsAlwaysSticky) return;
      


      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
    }
    reveal() {
      if (this.headerIsAlwaysSticky) return;
      


      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }
    reset() {
      if (this.headerIsAlwaysSticky) return;
      


      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }
  }
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
